import { generateId } from '@freelancer/datastore/testing/helpers';
import { ExternalCredentialStatusApi } from 'api-typings/external_credentials/external_credentials';
import type { AdminExternalCredentialAllocationLog } from './admin-external-credential-allocation-logs.model';

export interface GenerateAdminExternalCredentialAllocationLogOptions {
  readonly id?: number;
  readonly externalCredentialAllocationId?: number;
  readonly externalCredentialAllocationContextId?: number;
  readonly credentialStatus?: ExternalCredentialStatusApi;
  readonly timeLogged?: number;
  readonly adminUserId?: number;
  readonly expiryTime?: number;
}

export function generateAdminExternalCredentialAllocationLogObject({
  id = generateId(),
  externalCredentialAllocationId = generateId(),
  externalCredentialAllocationContextId,
  credentialStatus = ExternalCredentialStatusApi.ACTIVE,
  timeLogged = Date.now(),
  adminUserId = generateId(),
  expiryTime = Date.now() + 1000 * 60 * 60, // 1 hour later
}: GenerateAdminExternalCredentialAllocationLogOptions): AdminExternalCredentialAllocationLog {
  return {
    id,
    externalCredentialAllocationId,
    externalCredentialAllocationContextId,
    credentialStatus,
    timeLogged,
    adminUserId,
    expiryTime,
  };
}
